import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";
import greenArrow from "@/assets/icons/arrowCalendarRightGreen.svg";

import { TopBarProps } from "./types";
import styles from "./TopBar.module.scss";

export const TopBar: React.FC<TopBarProps> = ({
	items,
	basePath,
	onItemClick,
	breakPoint = MediaBreakPoints.MOBILE_LARGE,
	alwaysTabs = false,
}) => {
	const navigate = useNavigate();
	const location = useLocation();
	const windowWidth = useCurrentWidth();

	const [activeItemId, setActiveItemId] = useState<string>("");

	useEffect(() => {
		const currentPath = location.pathname;
		const activeItem = items.find(item => {
			const fullPath = `${basePath}/${item.path}`;
			return currentPath === fullPath ||
			       currentPath === `${fullPath}/` ||
			       currentPath.startsWith(`${fullPath}/`);
		});

		if (activeItem) {
			setActiveItemId(activeItem.id);
		} else if (currentPath === basePath && (windowWidth >= breakPoint || alwaysTabs) && items.length > 0) {
			const firstItem = items[0];
			navigate(`${basePath}/${firstItem.path}`);
			setActiveItemId(firstItem.id);
		}
	}, [location.pathname, basePath, items, windowWidth, breakPoint, navigate]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);

	const handleNavigate = (item: TopBarProps["items"][0]) => {
		setActiveItemId(item.id);
		const fullPath = item.absolutePath ? item.path : `${basePath}/${item.path}`;
		navigate(fullPath);

		if (onItemClick) {
			onItemClick(item);
		}
	};

	const isDesktop = windowWidth > breakPoint;

	if (!isDesktop && !alwaysTabs) {
		return (
			<nav className={styles.mobileCardList}>
				{items.map((item) => (
					<div
						key={item.id}
						className={styles.mobileCard}
						onClick={() => handleNavigate(item)}
					>
						<div className={styles.mobileCardContent}>
							<div className={styles.mobileCardTitleRow}>
								<div className={styles.mobileCardTitleLeft}>
									{item.icon && <img src={item.icon} alt="" className={styles.mobileCardIcon} />}
									<span className={styles.mobileCardTitle}>{item.text}</span>
								</div>
								<img src={greenArrow} alt="" className={styles.mobileCardArrow} />
							</div>
							{item.description && (
								<div className={styles.mobileCardDescription}>{item.description}</div>
							)}
							{item.extraContent && (
								<div className={styles.mobileCardExtraContent} onClick={(e) => e.stopPropagation()}>
									{item.extraContent}
								</div>
							)}
						</div>
					</div>
				))}
			</nav>
		);
	}

	return (
		<nav className={styles.wrapper}>
			<ul className={styles.wrapper_menu}>
				{items.map((item) => (
					<li
						key={item.id}
						className={
							activeItemId === item.id
								? styles.item
								: styles.item_Opacity
						}
						onClick={() => handleNavigate(item)}
					>
						{item.icon && <img src={item.icon} alt="" className={styles.tabIcon} />}
						<span>{item.text}</span>
						{item.badge !== undefined && item.badge > 0 && (
							<span className={styles.badge}>{item.badge}</span>
						)}
						{item.img && <img src={item.img} alt={item.text} />}
					</li>
				))}
			</ul>
		</nav>
	);
};

